/**
 * 用于存储公共的数据字典数据
 * */
import {
  getAppList,
  getDataDictionary,
  getOrganizationTypeList,
  getOrganizationLevelList
} from '@/api/index'


const state = {
  dict: {},
  // 系统应用列表数据
  appSystemList: [],
  menuLevel: [{
    name: '模块',
    level: 1
  }, {
    name: '页面',
    level: 2
  }, {
    name: '选项卡',
    level: 3
  }, {
    name: '按钮',
    level: 4
  }],
  organizationTypeList: [],
  organizationLevelList: []
}

const actions = {
  // 获取字典
  getDictionary ({ commit, state }, name) {
    return new Promise(resolve => {
      if (state.dict[name] && state.dict[name].length) {
        resolve(state.dict[name]);
        return;
      }
      getDataDictionary(name).then(res => {
        commit('UPDATE_SYSTEM_DICT', { name: name, data: res.body })
        resolve(res.body);
      })
    })
  },
  // 获取系统应用列表数据
  getDictionaryAppSystemList ({ commit, state }) {
    return new Promise(resolve => {
      getAppList({ name: '', current: 1, size: 0 }).then(res => {
        commit('UPDATE_APP_SYSTEM_LIST', res.body.records)
        resolve(res.body.records);
      })
    })
  },
  // 获取系统组织类型列表数据
  getDictionaryOrganizationTypeList ({ commit, state }, orgId = 1) {
    return new Promise(resolve => {
      // 之前做的缓存，由于别的页面添加了部门这边没有做刷新  所以注释掉缓存
      // if(state.organizationTypeList.length && orgId === 1){
      // 	resolve(state.organizationTypeList);
      // 	return;
      // }
      getOrganizationTypeList(orgId).then(res => {
        commit('UPDATE_ORGANIZATION_TYPE_LIST', res.body)
        resolve(res.body);
      })
    })
  },

  // 获取系统性质层级列表数据
  getDictionaryOrganizationLevelList ({ commit, state },) {
    return new Promise(resolve => {
      if (state.organizationLevelList.length) {
        resolve(state.organizationLevelList);
        return;
      }
      getOrganizationLevelList().then(res => {
        commit('UPDATE_ORGANIZATION_LEVEL_LIST', res.body)
        resolve(res.body);
      })
    })

  },
  // 获取系统菜单类型列表数据
  getDictionaryMenuLevel ({ commit, state },) {
    return new Promise(resolve => {
      if (state.menuLevel.length) {
        resolve(state.menuLevel);
        return;
      }
      getDataDictionary().then(res => {
        commit('UPDATE_MENU_LEVEL_LIST', res.body.records)
        resolve(res.body.records);
      })
    })
  },
}

const getters = {

};

const mutations = {
  UPDATE_SYSTEM_DICT (state, data) {
    state.dict[data.name] = [...data.data]
    state.dict = { ...state.dict }
  },
  /**
   * 更新系统应用列表数据
   * @param state
   * @param data
   * @constructor
   */
  UPDATE_APP_SYSTEM_LIST (state, data) {
    state.appSystemList = data;
  },
  /**
   * 更新系统菜单等级
   * @param state
   * @param data
   * @constructor
   */
  UPDATE_MENU_LEVEL_LIST (state, data) {
    state.menuLevel = [...data];
  },
  /**
   * 更新组织架构类型
   * @param state
   * @param data
   * @constructor
   */
  UPDATE_ORGANIZATION_TYPE_LIST (state, data) {
    state.organizationTypeList = [...data];
  },
  /**
   * 更新组织架构层级标签
   * @param state
   * @param data
   * @constructor
   */
  UPDATE_ORGANIZATION_LEVEL_LIST (state, data) {
    state.organizationLevelList = [...data];
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
